import React from 'react';
import ReactPWAInstallProvider from 'react-pwa-install';
import { SnackbarProvider } from 'material-ui-snackbar-provider';

import { ThemeProvider } from '@material-ui/core/styles';

import AppRouter from './components/AppRouter';
import { AuthContextProvider } from './context/authContext';
import { NavContextProvider } from './context/navContext';
import { SelectedStoreContextProvider } from './context/selectedStoreContext';
import theme from './styles/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthContextProvider>
        <NavContextProvider>
          <SelectedStoreContextProvider>
            <ReactPWAInstallProvider>
              <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000 }}>
                <AppRouter />
              </SnackbarProvider>
            </ReactPWAInstallProvider>
          </SelectedStoreContextProvider>
        </NavContextProvider>
      </AuthContextProvider>
    </ThemeProvider>
  );
}

export default App;
